import { reactive } from "vue";
import { useDefaultThumbnail } from "../utils/thumbnail";
export default {
  name: "KilaKilaPostArticleCard",
  props: {
    article: {
      type: Object,
      require: true
    },
    reverse: {
      type: Boolean,
      require: false
    }
  },
  setup: function setup(props) {
    var cardClass = reactive(["post-article-card"]);
    var thumbailLinkClass = reactive(["post-article-thumbail-link"]);

    if (props.reverse) {
      cardClass.push("post-article-card-reversed");
      thumbailLinkClass.push("post-article-thumbail-link-reversed");
    }

    return {
      cardClass: cardClass,
      thumbailLinkClass: thumbailLinkClass,
      useDefaultThumbnail: useDefaultThumbnail
    };
  }
};